import { atom } from "recoil";

export type DueDiligenceChatActionData = {
  name?: string;
  address?: string;
  cadastralReference?: string;
  propertyType?: string;
};

export type DueDiligenceChatActionState = {
  chatId?: string;
  data: DueDiligenceChatActionData;
  miniWidgetVisible: boolean;
} | null;

export const dueDiligenceChatActionAtom = atom<DueDiligenceChatActionState>({
  key: "dueDiligenceChatActionState",
  default: null,
});
